<!--
  --
  -- ページのコンテナ コンポーネント
  --
  -->
<template>
  <v-container :class="classes">
    <slot />
  </v-container>
</template>

<script>
export default {
  name: 'CContainer',
  props: {
    /**
     * Form 表示
     */
    form: {
      type: Boolean,
      default: false
    },

    /**
     * 幅広の Form 表示
     */
    wide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * コンテナに適用するクラス
     */
    classes () {
      if (!this.form) {
        return 'container--fluid'
      } else if (this.wide) {
        return 'max-w-xl'
      }
      return 'max-w-md'
    }
  }
}
</script>
